var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "click": _vm.triggerInput
    }
  }, [_vm._t("default"), _c('img', {
    staticClass: "stem",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.DomString
    }
  }), _c('input', _vm._b({
    staticClass: "upload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event);
      },
      "click": function click($event) {
        return _vm.clear($event);
      }
    }
  }, 'input', _vm.$attrs, false))], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }